import { AbiRegistry, Address, ResultsParser, SmartContract, Transaction } from "@multiversx/sdk-core";
import axios from "axios";
import elrondHelper from "@/helpers/elrond";
import ENV from "@/constants/env";
import { BigNumber } from "bignumber.js";
import { BigUIntValue, TokenTransfer } from "@multiversx/sdk-core/out";

class OneDex {
  public contract: SmartContract;
  public abiRegistry: AbiRegistry;
  public resultParser: ResultsParser;

  abiJson: string;
  abiInterface: string;

  constructor() {
    this.contract = new SmartContract({
      address: new Address(ENV.CONTRACT_ONEDEX),
    });
    this.resultParser = new ResultsParser();

    this.abiJson = "onedex-sc";
    this.abiInterface = "OneDex";
  }

  public async getContractAbi(): Promise<AbiRegistry> {
    if (!this.abiRegistry) {
      const response = await axios.get(`/abi/${ this.abiJson }.abi.json`);

      this.abiRegistry = AbiRegistry.create(response.data);

      this.contract = new SmartContract({
        address: this.contract.getAddress(),
        abi: this.abiRegistry,
      });
    }

    return this.abiRegistry;
  }

  async swapMultiTokensFixedOutput(tokenIn: string, tokenOut: string, amountIn: BigNumber, amountOutRequired: BigNumber): Promise<Transaction> {
    await this.getContractAbi();

    const interaction = this.contract.methods.swapMultiTokensFixedOutput([amountOutRequired, false, tokenIn, tokenOut])
      .withSingleESDTTransfer(TokenTransfer.fungibleFromBigInteger(tokenIn, amountIn));

    return interaction.withGasLimit(20_000_000).buildTransaction();
  }

  async getAmountOut(tokenIn: string, tokenOut: string, amountIn: BigNumber): Promise<BigNumber> {
    await this.getContractAbi();

    const interaction = this.contract.methods.getAmountOut([tokenIn, tokenOut, amountIn]);
    const query = interaction.check().buildQuery();
    const response = await elrondHelper.cachedProxy.queryContract(query);

    if (!response.returnData.length) {
      return null;
    }

    const { firstValue } = this.resultParser.parseQueryResponse(response, interaction.getEndpoint());

    return (firstValue as BigUIntValue).valueOf();
  }

  async getAmountIn(tokenIn: string, tokenOut: string, amountOut: BigNumber): Promise<BigNumber> {
    await this.getContractAbi();

    const interaction = this.contract.methods.getAmountIn([tokenIn, tokenOut, amountOut]);
    const query = interaction.check().buildQuery();
    const response = await elrondHelper.cachedProxy.queryContract(query);

    if (!response.returnData.length) {
      return null;
    }

    const { firstValue } = this.resultParser.parseQueryResponse(response, interaction.getEndpoint());

    return (firstValue as BigUIntValue).valueOf();
  }
}

const oneDexContract = new OneDex();

export default oneDexContract;
